import { render, staticRenderFns } from "./HistoriqueDetail.vue?vue&type=template&id=3b9f119c&"
import script from "./HistoriqueDetail.vue?vue&type=script&lang=js&"
export * from "./HistoriqueDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports